import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { ADMIN_COLORS } from '@/constants/admin';

interface GradientBorderFrameProps {
  children: React.ReactNode;
  style?: ViewStyle;
  innerStyle?: ViewStyle;
  borderWidth?: number;
  borderRadius?: number;
  padding?: number;
  isInnerFrame?: boolean;
}

export const GradientBorderFrame: React.FC<GradientBorderFrameProps> = ({
  children,
  style,
  innerStyle,
  borderWidth = 3,
  borderRadius = 32,
  padding = 5,
  isInnerFrame = false,
}) => {
  // Gradient colors from Figma: linear-gradient(180.09deg, #4773FE 11.38%, #BE5EC8 63.85%, #F55560 97.73%)
  const gradientColors = [
    ADMIN_COLORS.BULLETINS.GRADIENT_BLUE,    // #4773FE
    ADMIN_COLORS.BULLETINS.GRADIENT_PURPLE,  // #BE5EC8
    ADMIN_COLORS.BULLETINS.GRADIENT_RED,     // #F55560
  ];
  
  const gradientLocations = [0.1138, 0.6385, 0.9773]; // From Figma

  // Visible gradient edge thickness
  const edge = Math.max(1, Math.floor(borderWidth));
  // Respect provided borderRadius for outer frame
  const gradientBorderRadius = borderRadius;
  const innerBorderRadius = Math.max(0, gradientBorderRadius - edge);

  return (
    <View style={[{ flex: 1, width: '100%' }, style]}>
      <LinearGradient
        colors={gradientColors}
        locations={gradientLocations}
        start={{ x: 0, y: 0 }}
        end={{ x: 0, y: 1 }} // 180deg gradient (top to bottom)
        style={[
          styles.gradientContainer,
          {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderTopLeftRadius: gradientBorderRadius,
            borderTopRightRadius: gradientBorderRadius,
            borderBottomLeftRadius: 0, // No bottom border radius by default (desktop frame style)
            borderBottomRightRadius: 0, // No bottom border radius by default (desktop frame style)
          },
        ]}
      />
      <View
        style={[
          styles.innerContainer,
          {
            backgroundColor: ADMIN_COLORS.BULLETINS.FRAME_BACKGROUND,
            borderTopLeftRadius: innerBorderRadius,
            borderTopRightRadius: innerBorderRadius,
            borderBottomLeftRadius: 0, // No bottom border radius
            borderBottomRightRadius: 0, // No bottom border radius
            flex: 1,
            marginTop: edge, // Top border
            marginLeft: edge, // Left border
            marginRight: edge, // Right border
            marginBottom: 0, // No bottom border
          },
          innerStyle,
        ]}
      >
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  gradientContainer: {
    // No border styles needed - gradient background creates the border effect
    // Temporary debug: add a visible border to see the gradient container bounds
    // borderWidth: 1,
    // borderColor: 'red',
  },
  innerContainer: {
    flex: 1,
  },
});
